import { convertMinutesToHours } from '@nile/mangifera/src/Utils/helpers';
import { Timer } from '@styled-icons/remix-fill';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import {
  BackgroundIcon,
  SLAOverdueTimer,
  DisabledTag,
  AppContext
} from '@nile/components';
import { Tooltip } from 'react-clone-tippy';
import envConfig from '@nile/home/src/Config/env';
import dayjs from 'dayjs';
import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';

function TimerCell(props) {
  const { cell } = props;
  const appContext = useContext(AppContext);
  const { company } = appContext;
  let value = cell.value;
  const field = cell?.column?.field || {};
  const ticket = cell.row.original;
  let tooltipValue = '';
  if (value && value > 0) {
    value = (
      <div className="flex g5">
        <SVGIcon name="HourGlassWireStart" />
        <div>{convertMinutesToHours(value)}</div>
      </div>
    );
  }
  if (field.name === 'resolutionTimer') {
    if (ticket.resolutionViolated) {
      tooltipValue = dayjs(ticket.resolutionDueTime).format(
        `${company?.dateFormat || 'MMM DD'}, ${company?.timeFormat ||
          'hh:mm A'}`
      );
      value = (
        <div className="flex g5">
          <SVGIcon name="HourglasswireEnd" color="#d72c0d" />
          <div>
            <TextStyle variation="negative">
              <FormattedMessage id="ticket.list.resolutionTimer.overDue" />
            </TextStyle>
          </div>
        </div>
      );
    } else if (ticket.resolutionPauseTime)
      value = (
        <div className="flex g5">
          <SVGIcon name="HourGlassWirePaused" />
          <div>
            <FormattedMessage id="ticket.list.resolutionTimer.paused" />
          </div>
        </div>
      );
    else if (!ticket.resolutionViolated && ticket.resolutionTime)
      value = (
        <div className="flex g5">
          <SVGIcon name="HourglasswireEnd" />
          <div>
            <FormattedMessage id="ticket.list.resolutionTimer.achieved" />
          </div>
        </div>
      );
  }
  if (field.name === 'firstResponseTimer') {
    if (ticket.firstResponseViolated) {
      tooltipValue = dayjs(ticket.firstResponseDueTime).format(
        `${company?.dateFormat || 'MMM DD'}, ${company?.timeFormat ||
          'hh:mm A'}`
      );
      value = (
        <div className="flex g5">
          <SVGIcon name="HourglasswireEnd" color="#d72c0d" />
          <div>
            <TextStyle variation="negative">
              <FormattedMessage id="ticket.list.resolutionTimer.overDue" />
            </TextStyle>
          </div>
        </div>
      );
    } else if (!ticket.firstResponseViolated && ticket.firstResponseTime)
      value = (
        <div className="flex g5">
          <SVGIcon name="HourglasswireEnd" />
          <div>
            <FormattedMessage id="ticket.list.resolutionTimer.achieved" />
          </div>
        </div>
      );
  }
  if (!value)
    value = (
      <TextStyle disabled>
        <FormattedMessage id="app.noData.message" />
      </TextStyle>
    );
  const defaultValue = value;
  return (
    <div className="w-80 flex actr">
      <Tooltip
        title={tooltipValue}
        delay={300}
        duration={250}
        position="bottom"
        inertia
        trigger="mouseenter"
        animation="shift"
        animateFill={false}
      >
        <div className="ellipsis">{value}</div>
      </Tooltip>
    </div>
  );
}

export default TimerCell;
